module.exports = __webpack_public_path__ + "static/media/arrow-accordeon.750ad181.png";